// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1B9R_","footer":"styles_footer__3jAAP","passCodeTooltip":"styles_passCodeTooltip__2GE52"};